import './app.scss'
import "babel-polyfill"
import 'url-search-params-polyfill'
import "lib/jquery/csrf-token"
import "lib/jquery/bootstrap-carousel-mobile"
import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import getStore from './store/index';
import Page from './containers/page';

const pageState = window.currentPageState || {guid: null, pageType: null}
const store = getStore(Object.assign({}, pageState, {
  site: window.currentSite
}))

export default class App extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <Router>
          <Page scale={1} />
        </Router>
      </Provider>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/app/site/app.js